import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// ── Domain Lock ──
// PixAlloy only runs on authorized domains.
// Add localhost/127.0.0.1 for development.
const ALLOWED_HOSTS = [
  'pixalloy.com',
  'www.pixalloy.com',
  'localhost',
  '127.0.0.1',
];

const host = window.location.hostname;
if (!ALLOWED_HOSTS.includes(host) && !host.endsWith('.pixalloy.com')) {
  document.getElementById('root').innerHTML = `
    <div style="display:flex;align-items:center;justify-content:center;height:100vh;background:#111;color:#f87171;font-family:monospace;font-size:16px;text-align:center;padding:40px;">
      <div>
        <h1 style="font-size:24px;margin-bottom:16px;">⚠ Unauthorized Domain</h1>
        <p>PixAlloy is only licensed to run on <strong>pixalloy.com</strong></p>
        <p style="color:#666;margin-top:12px;">Current host: ${host}</p>
      </div>
    </div>`;
} else {
  // ── COOP/COEP Header Check ──
  // SharedArrayBuffer (needed for worker mode) requires these headers.
  // Without them, the app falls back to single-thread mode.
  if (typeof SharedArrayBuffer === 'undefined') {
    console.warn(
      '[PixAlloy] SharedArrayBuffer is not available. This usually means your server is not sending the required headers:\n' +
      '  Cross-Origin-Opener-Policy: same-origin\n' +
      '  Cross-Origin-Embedder-Policy: require-corp\n' +
      'The app will run in single-thread mode (slower on large images).'
    );
  }

  ReactDOM.createRoot(document.getElementById('root')).render(<App />)
}
